import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as reduxAsyncConnect } from 'redux-connect';
import { reducer as form } from 'redux-form';
// import { reducer as hapines } from './react-hapines';
import auth from './modules/auth';
import counter from './modules/counter';
import info from './modules/info';
import items from '../pages/Items/reducer';
import labels from '../components/labels/reducer';
import eventDetail from '../components/EventDetails/reducer';
import globleObject from '../components/globleObject/reducer';
import giftList from '../pages/eventManagement/page/GiftList/reducer';
import storeLocation from '../pages/NewHeader/reducer';
import giftListGuestViewList from '../pages/eventManagement/page/GiftListGuestView/reducer';
import createEvent from '../pages/createEvent/components/createEvent/reducer';
import eventDetails from '../pages/eventManagement/page/EventData/DatosDeMiEvento/reducer';
import eventcategory from '../components/eventcategory/reducer';
import giftRegistryAddress from '../pages/createEvent/components/GiftRegistryAddress/reducer';
import createEventObject from '../pages/createEvent/reducer';
import giftRegistryNewAddress from '../pages/createEvent/components/GiftRegistryNewAddress/reducer';
import contractPage from '../pages/createEvent/components/ContractPage/reducer';
import closingGiftPriceRange from '../pages/eventManagement/page/EventData/ClosureGift/reducer';
import searchResult from '../pages/BrowseAndNavigate/SearchEvent/reducer';
import targetterContent from '../pages/BrowseAndNavigate/GiftRegistryhome/reducer';
import getMarketingLandingPage from '../pages/BrowseAndNavigate/MesaHomePage/reducer';
import allowedEventTypes from '../pages/BrowseAndNavigate/AllowedEventTypes/reducer';
import deliveryAddress from '../pages/eventManagement/page/EventData/DeliveryAddress/reducer';
import notifications from '../components/Notifications/reducer';
import giftPreferences from '../pages/eventManagement/page/EventData/GiftPreferences/reducer';
import footer from '../components/Footer/reducer';
import user from '../pages/Accounts/createAccount/reducer';
// import multipleEvents from '../pages/BrowseAndNavigate/MultipleEvents/reducer';
import eCardDetails from '../pages/eventManagement/page/EventData/CelebratedCard/reducer';
import openingGift from '../pages/eventManagement/page/EventData/GiftOpening/reducer';
import accountSummary from '../pages/BrowseAndNavigate/AccountSummary/reducer';
import SearchedPoductData from '../pages/BrowseAndNavigate/BrowseAndNevigateSearch/reducer';
import NewSearchedPoductData from '../pages/BrowseAndNavigate/NewBrowseAndNevigateSearch/reducer';
import megaMenuData from '../pages/BrowseAndNavigate/MegaMenu/reducer';
import linksMenuData from '../pages/BrowseAndNavigate/MegaMenu/newHeaderReducer';
import cartCountData from '../pages/BrowseAndNavigate/MiniCart/reducer';
import newMegaMenuData from '../pages/BrowseAndNavigate/NewMegaMenu/reducer';
import globalData from '../pages/BrowseAndNavigate/GlobalContent/reducer';
import marketingContentSection from '../pages/BrowseAndNavigate/MarketingContentSection/reducer';
import cscAdminProfile from '../pages/BrowseAndNavigate/CscAdminProfile/reducer';

export default combineReducers({
  routing: routerReducer,
  reduxAsyncConnect,
  // hapines,
  auth,
  counter,
  info,
  items,
  labels,
  eventDetail,
  globleObject,
  SearchedPoductData,
  megaMenuData,
  linksMenuData,
  cartCountData,
  giftList,
  storeLocation,
  createEvent,
  giftRegistryAddress,
  eventcategory,
  createEventObject,
  giftRegistryNewAddress,
  contractPage,
  searchResult,
  targetterContent,
  eventDetails,
  deliveryAddress,
  notifications,
  user,
  giftPreferences,
  eCardDetails,
  openingGift,
  closingGiftPriceRange,
  accountSummary,
  footer,
  giftListGuestViewList,
  getMarketingLandingPage,
  allowedEventTypes,
  newMegaMenuData,
  globalData,
  NewSearchedPoductData,
  marketingContentSection,
  cscAdminProfile,
});
